export const ROOM_BOOKING_OPTIONS = {
  ROOM_ONLY: 'roomOnly',
  WITH_BREAKFAST: 'withBreakfast',
  WITH_SPA: 'withSpa',
};

const LEGACY_OPTION_MAP = {
  'room-only': ROOM_BOOKING_OPTIONS.ROOM_ONLY,
  breakfast: ROOM_BOOKING_OPTIONS.WITH_BREAKFAST,
  spa: ROOM_BOOKING_OPTIONS.WITH_SPA,
};

/** Maps UI / legacy values to API booking option strings. */
export function normalizeRoomBookingOption(option) {
  if (!option) return ROOM_BOOKING_OPTIONS.ROOM_ONLY;
  if (Object.values(ROOM_BOOKING_OPTIONS).includes(option)) return option;
  return LEGACY_OPTION_MAP[option] || ROOM_BOOKING_OPTIONS.ROOM_ONLY;
}

export function isWithBreakfastOption(option) {
  return normalizeRoomBookingOption(option) === ROOM_BOOKING_OPTIONS.WITH_BREAKFAST;
}

export function isWithSpaOption(option) {
  return normalizeRoomBookingOption(option) === ROOM_BOOKING_OPTIONS.WITH_SPA;
}

export function roomBookingOptionLabel(option) {
  const normalized = normalizeRoomBookingOption(option);
  if (normalized === ROOM_BOOKING_OPTIONS.WITH_BREAKFAST) return 'Room + Breakfast';
  if (normalized === ROOM_BOOKING_OPTIONS.WITH_SPA) return 'Room + Spa';
  return 'Room Only';
}

export const DEFAULT_ROOM_FORM_OPTIONS = {
  roomOnly: true,
  withBreakfast: false,
  withSpa: false,
};

export function mergeRoomFormOptions(options) {
  return {
    ...DEFAULT_ROOM_FORM_OPTIONS,
    ...(options && typeof options === 'object' ? options : {}),
  };
}
